import type { QueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../lib/queryKeys';

/**
 * The one place the processor-fee pin's post-mutation refresh set is declared, shared by both
 * pin actions (Record — {@link useBookProcessorFee}; step-aside — {@link useStepAsideProcessorFee}).
 * Recording OR stepping aside changes the same three surfaces, so a single change to that set must
 * touch one site, not two:
 *  - `sortInboxAll()` — the 2-element prefix covering the display ledger (where the pin lives) AND
 *    the NeedsAction feed.
 *  - `reports.all` — every report/preflight key (the must-record gate + the pin both ride preflight).
 *  - `health()` — finance health (a fee dated into a filed period flags it for amendment).
 */
export function invalidateFeePinQueries(queryClient: QueryClient): void {
  queryClient.invalidateQueries({ queryKey: queryKeys.finance.sortInboxAll() });
  queryClient.invalidateQueries({ queryKey: queryKeys.finance.reports.all });
  queryClient.invalidateQueries({ queryKey: queryKeys.finance.health() });
}
